import React, { useEffect, useRef } from "react";

const MapWithMarkers = () => {
  const mapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!mapRef.current) return; // Проверка, что ref существует

    const cities = [
      { lat: 51.2277, lng: 6.7735, name: "Дюссельдорф" },
      { lat: 51.2311, lng: 6.7724, name: "Нойс" },
      { lat: 51.2262, lng: 6.7799, name: "Дуйсбург" },
    ];

    const map = new google.maps.Map(mapRef.current, {
      center: cities[0], // Центр карты (Дюссельдорф)
      zoom: 15,
    });

    cities.forEach((city) => {
      new google.maps.Marker({
        position: city,
        map: map,
        title: city.name,
      });
    });
  }, []);

  useEffect(() => {
    if (!window.google) {
      console.error("Google Maps API не загружен");
      return;
    }
  }, []);
  return <div ref={mapRef} style={{ width: "100%", height: "420px" }} />;
};

export default MapWithMarkers;
